import { Dialog, DialogContent, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Photo } from '@features/visits/api';

type VisitDetailPhotoViewDialogProps = {
  photo: Photo | null;
  onClose: () => void;
};

const VisitDetailPhotoViewDialog = ({ photo, onClose }: VisitDetailPhotoViewDialogProps) => {
  return (
    <Dialog open={!!photo} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogContent sx={{ p: 0, position: 'relative' }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: 'background.paper',
            '&:hover': { bgcolor: 'background.paper' },
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        {photo && (
          <Box>
            <img
              src={photo.url}
              alt={photo.description || 'Hairstyle photo'}
              style={{ width: '100%', display: 'block' }}
            />
            {photo.description && (
              <Box p={2}>
                <Typography variant="body1">{photo.description}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {new Date(photo.uploadedAt).toLocaleString()}
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VisitDetailPhotoViewDialog;
